import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=327d46ff&scoped=true&"
import script from "./terms.vue?vue&type=script&lang=js&"
export * from "./terms.vue?vue&type=script&lang=js&"
import style0 from "./terms.vue?vue&type=style&index=0&id=327d46ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327d46ff",
  null
  
)

export default component.exports